import React from 'react';
import Modal from 'react-modal';
import { Box, Typography } from '@mui/material';

const leftBoxSx = { width: '40%', textAlign: 'left' };
const rightBoxSx = { width: '60%', textAlign: 'left', wordBreak: 'break-word', overflowWrap: 'break-word' };

const AnalyteFlagModal = ({ open, onClose, row }) => {
  if (!row) return null;

  return (
    <Modal
      className="modal"
      overlayClassName="modalOverlay"
      aria-modal="true"
      contentLabel="Analyte Flag Details"
      shouldCloseOnOverlayClick={true}
      isOpen={open}
      onRequestClose={onClose}
    >
      <div className="modalHeader">Test Result Flags</div>
      <div className="modalContent">
        <div className="modalSection">
          <div className="sectionHeading center">
            <Typography variant="body1" gutterBottom>{row.code || 'Analyte Flags'}</Typography>
          </div>
          <Box sx={{ mt: 4, pl: 4, pr: 4 }}>
            <Box display="flex" flexDirection="row" mb={1}>
              <Box sx={leftBoxSx}>
                <Typography>Value:</Typography>
              </Box>
              <Box sx={rightBoxSx}>
                <Typography>
                  {row.value !== null && row.value !== undefined ? Number(row.value).toFixed(2) : 'No Data'}
                </Typography>
              </Box>
            </Box>
            <Box display="flex" flexDirection="row" mb={1}>
              <Box sx={leftBoxSx}>
                <Typography>Z-Score:</Typography>
              </Box>
              <Box sx={rightBoxSx}>
                <Typography>
                  {row.zScore !== null && row.zScore !== undefined ? Number(row.zScore).toFixed(2) : 'No Data'}
                </Typography>
              </Box>
            </Box>
            <Box display="flex" flexDirection="row" mb={1}>
              <Box sx={leftBoxSx}>
                <Typography>Reason:</Typography>
              </Box>
              <Box sx={rightBoxSx}>
                  <Typography>
                  <ul style={{ margin: 0, paddingLeft: '0' }}>
                  {row.reason.map((r, idx) => (
                    <li key={idx}>
                      {r.reason}
                    </li>
                  ))}
                </ul>
                </Typography>
               
              </Box>
            </Box>
          </Box>
        </div>
      </div>
      <div className="modalButtons">
        <button
          onClick={onClose}
          className="modalButton"
          variant="contained"
          aria-label="close analyte flag modal"
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

export default AnalyteFlagModal;